export default __webpack_public_path__ + "static/media/fauna-docs-2018-p4.09b31f7a.png";